import React from 'react';
export var FixedToolbarIcon = function FixedToolbarIcon(props) {
  var primaryColor = props.primaryColor,
    label = props.label;
  return /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    style: {
      color: primaryColor,
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
      fill: "var(--ds-background-neutral-subtle, #00000000)"
    },
    "aria-label": label || undefined,
    role: label ? 'img' : 'presentation'
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0.75",
    y: "1.00586",
    width: "14.5",
    height: "13.9879",
    rx: "2.25",
    stroke: "currentColor",
    "stroke-width": "1.5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "4",
    y: "3.75586",
    width: "8",
    height: "1.5",
    fill: "currentColor"
  }));
};